<template>
    <div class="container">
        <top></top>
        <main>
            <steps></steps>
            <router-view/>
        </main>
    </div>
</template>

<script>
    import Top from '../components/general/Top'
    import Steps from '../components/general/Steps'

    export default {
        name: 'App',
        components:{
            'top': Top,
            'steps': Steps

        },
        methods: {
          getStepDetailHeight(element, lessSpace = true) {
            if (element) {
              let extraSpaceToSubtract = lessSpace ? 15 : 0;
              return window.innerHeight - element.getBoundingClientRect().top - extraSpaceToSubtract + 'px';
            }
          },
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/style";
</style>


// WEBPACK FOOTER //
// src/layouts/App.vue